import keycloak from "../../keycloak";
import axios from "axios";
import {showError} from "../notification/ToastManager";
import config from '../../config'

export async function saveUserFilters(login, tags, numberDCPerPage, filters) {
    let header = {
        headers: {
            'Authorization': 'Bearer ' + keycloak.token
        }
    }
    let result = {};
    let userFilters = {
        id: null,
        login: login,
        tags: tags,
        status: [],
        numberDCPerPage: numberDCPerPage,
        sortingField: null,
        sortingOrder: null,
        filters: filters ? JSON.stringify(filters) : {}
    };
    try {
        await axios.post(config.BACK_URL + "userFilters/save/", userFilters, header).then(response => {
            return result
        })
    } catch (e) {
        showError("Error", "An error was occurred when saving user filters.");
        result = {
            status: e.response.data.status,
            content: null
        }
        return result;
    }

    return result;
}

export async function getUserFilters(login) {
    let header = {
        headers: {
            'Authorization': 'Bearer ' + keycloak.token
        }
    }
    let result = {};
    try {
        await axios.get(config.BACK_URL + "userFilters/load/" + encodeURIComponent(login), header).then(response => {
            result= response.data;
        })
    } catch (e) {
        showError("Error", "An error was occurred when loading user filters.");
        result = {
            status: e.response.data.status,
            content: null
        }
        return result;
    }

    return result;
}

export async function updateNumberOfDCPerPage(login,numberDCPerPage) {
    let header = {
        headers: {
            'Authorization': 'Bearer ' + keycloak.token
        }
    }
    let result = {};
    let userFilters={id:null, login: login, Email: null, tags:null, numberDCPerPage: numberDCPerPage,sortingField:null,sortingOrder:null};

    try {
        await axios.post(config.BACK_URL + "userFilters/updateNumberOfDcPerPage",userFilters, header).then(response => {
            return result
        })
    } catch (e) {
        showError("Error", "An error was occurred when saving user filters.");
        result = {
            status: e.response.data.status,
            content: null
        }
        return result;
    }

    return result;
}

export async function updateStatus(login,status) {
    let header = {
        headers: {
            'Authorization': 'Bearer ' + keycloak.token
        }
    }
    let result = {};
    let userFilters={id:null, login: login, tags:null, status:status, numberDCPerPage: null,sortingField:null,sortingOrder:null};
    try {
        await axios.post(config.BACK_URL + "userFilters/updateStatus",userFilters, header).then(response => {
            return result
        })
    } catch (e) {
        showError("Error", "An error was occurred when saving user filters.");
        result = {
            status: e.response.data.status,
            content: null
        }
        return result;
    }

    return result;
}

export async function updateSorters(login,sortingField,sortingOrder) {
    let header = {
        headers: {
            'Authorization': 'Bearer ' + keycloak.token
        }
    }
    let result = {};
    let userFilters={id:null, login: login, tags:null, status:null, numberDCPerPage: null,sortingField:sortingField,sortingOrder:sortingOrder};
    try {
        await axios.post(config.BACK_URL + "userFilters/updateSorters",userFilters, header).then(response => {
            return result
        })
    } catch (e) {
        showError("Error", "An error was occurred when saving user filters.");
        result = {
            status: e.response.data.status,
            content: null
        }
        return result;
    }

    return result;
}
